import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, fmt } from "./kit";

/// AYVO Games (ayri uygulama) yonetimi: bu uygulamanin tum ayarlari ve rakamlari burada.
/// AYVO'nun kendi ayarlarina dokunmaz.
const AYARLAR = [
  ["gamesAppQuick", "Ludo hızlı eşleşme", "AYVO Games'te oda olmadan 1'e 1 Ludo eşleşmesi. (AYVO'daki Ludo bundan etkilenmez.)"],
  ["gamesAppBot", "AYVO Bot", "Rakip bulunamazsa masaya \"AYVO Bot\" oturur. Bot kazanırsa bahis sistemde kalır."],
  ["gamesAppTour", "Günlük turnuva", "Ludo turnuvası: gün içinde en çok maç kazananlara gece yarısı ödül yüklenir."],
  ["gamesAppCasino", "Casino sayfası", "Slot, rulet vb. AYVO oyunları herkese açılır. Kapalıyken yalnız deneme hesapları (gameTesters) görür. Mağaza onayından önce kapalı tutun."],
];

const kart = { background: "#fff", borderRadius: 14, padding: 16, boxShadow: "0 1px 3px #0001", marginBottom: 16 };

const Kart = ({ baslik, sag, children }) => (
  <div style={kart}>
    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 10, gap: 8 }}>
      <h6 style={{ fontWeight: 800, margin: 0 }}>{baslik}</h6>
      {sag}
    </div>
    {children}
  </div>
);
const tarih = (d) => new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

const Oyuncular = () => {
  const [q, setQ] = useState("");
  const [d, setD] = useState(null);
  const yukle = (x) => api.gappPlayers(x).then((r) => r?.status && setD(r));
  useEffect(() => { yukle(""); }, []);
  const coin = async (p) => {
    const v = Number(window.prompt(`${p.username} — eklenecek oyun coini (düşmek için eksi yazın)`, "1000"));
    if (!v) return;
    const r = await api.gappCoin(p.userId, v);
    if (!r?.status) return window.alert(r?.message || "Olmadı");
    yukle(q);
  };
  const engel = async (p) => {
    if (!window.confirm(`${p.username} ${p.isBlock ? "engeli kaldırılsın" : "engellensin"} mi?`)) return;
    await api.gappBlock(p.userId, !p.isBlock);
    yukle(q);
  };
  return (
    <Kart baslik={`Oyuncular (${d?.total ?? "…"})`} sag={
      <form className="d-flex" style={{ gap: 6 }} onSubmit={(e) => { e.preventDefault(); yukle(q); }}>
        <input className="form-control form-control-sm" placeholder="Kullanıcı adı / ID" value={q} onChange={(e) => setQ(e.target.value)} />
        <button className="btn btn-sm btn-primary">Ara</button>
      </form>}>
      <div style={{ overflowX: "auto" }}>
        <table className="table table-sm" style={{ fontSize: 13 }}>
          <thead><tr><th>Kullanıcı adı</th><th>ID</th><th>Oyun coini</th><th>Harcadı</th><th>Kayıt</th><th /></tr></thead>
          <tbody>
            {(d?.players || []).map((p) => (
              <tr key={p.userId} style={{ opacity: p.isBlock ? 0.5 : 1 }}>
                <td><b>{p.username}</b><div style={{ fontSize: 11, color: "#64748B" }}>{p.name}</div></td>
                <td>{p.uniqueID}</td>
                <td>{fmt(p.gameCoin)}</td>
                <td>{fmt(p.spentTl)} ₺</td>
                <td>{tarih(p.at)}</td>
                <td style={{ whiteSpace: "nowrap" }}>
                  <button className="btn btn-sm btn-outline-primary" onClick={() => coin(p)}>Coin</button>{" "}
                  <button className={`btn btn-sm ${p.isBlock ? "btn-success" : "btn-outline-danger"}`} onClick={() => engel(p)}>{p.isBlock ? "Aç" : "Engelle"}</button>
                </td>
              </tr>
            ))}
            {d && !d.players.length && <tr><td colSpan={6} style={{ color: "#9CA3AF" }}>Oyuncu yok</td></tr>}
          </tbody>
        </table>
      </div>
    </Kart>
  );
};

const Satislar = () => {
  const [gun, setGun] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { api.gappSales(gun).then((r) => r?.status && setD(r)); }, [gun]);
  const s = d?.summary || {};
  return (
    <Kart baslik={`Satışlar — son ${gun} gün`} sag={
      <select className="form-control form-control-sm" style={{ width: 110 }} value={gun} onChange={(e) => setGun(Number(e.target.value))}>
        {[1, 7, 30, 90, 365].map((x) => <option key={x} value={x}>{x} gün</option>)}
      </select>}>
      <div className="d-flex" style={{ gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
        {[["Ciro", `${fmt(s.tl || 0)} ₺`, "#16A34A"], ["Satış", fmt(s.adet || 0)], ["Satılan coin", fmt(s.coin || 0)]].map(([a, v, r]) => (
          <div key={a} style={{ flex: "1 1 120px", background: "#F8FAFF", borderRadius: 12, padding: 12 }}>
            <div style={{ fontSize: 12, color: "#64748B" }}>{a}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: r || "#0F172A" }}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 11, color: "#94A3B8", marginBottom: 6 }}>Ciroda Apple/Google payı düşülmemiştir. Deneme (sandbox) alımları cirodan sayılmaz.</div>
      {!!(d?.daily || []).length && (
        <table className="table table-sm" style={{ fontSize: 13 }}>
          <thead><tr><th>Gün</th><th>Satış</th><th>Ciro</th></tr></thead>
          <tbody>{d.daily.map((g) => <tr key={g._id}><td>{g._id}</td><td>{g.adet}</td><td>{fmt(g.tl)} ₺</td></tr>)}</tbody>
        </table>
      )}
      <div style={{ overflowX: "auto" }}>
        <table className="table table-sm" style={{ fontSize: 13 }}>
          <thead><tr><th>Zaman</th><th>Kullanıcı</th><th>Paket</th><th>Tutar</th><th /></tr></thead>
          <tbody>
            {(d?.recent || []).map((r, i) => (
              <tr key={i}><td>{tarih(r.at)}</td><td>{r.user}</td><td>{fmt(r.coin)} coin</td><td>{fmt(r.tl)} ₺</td><td>{r.environment !== "production" && <span className="badge badge-warning">deneme</span>}</td></tr>
            ))}
            {d && !d.recent.length && <tr><td colSpan={5} style={{ color: "#9CA3AF" }}>Henüz satış yok</td></tr>}
          </tbody>
        </table>
      </div>
    </Kart>
  );
};

const Casino = ({ kaydet, cfg }) => {
  const [d, setD] = useState(null);
  const yukle = () => api.gappCasino().then((r) => r?.status && setD(r));
  useEffect(() => { yukle(); }, []);
  const toplam = (d?.games || []).reduce((a, g) => a + g.profit, 0);
  return (
    <Kart baslik="Casino oyunları" sag={<span style={{ fontSize: 13, fontWeight: 700, color: toplam >= 0 ? "#16A34A" : "#DC2626" }}>Toplam kâr: {toplam >= 0 ? "+" : ""}{fmt(toplam)}</span>}>
      <div style={{ overflowX: "auto" }}>
        <table className="table table-sm" style={{ fontSize: 13 }}>
          <thead><tr><th>Oyun</th><th>Yatan</th><th>Ödenen</th><th>Kâr</th><th>Geri ödeme</th><th /></tr></thead>
          <tbody>
            {(d?.games || []).map((g) => (
              <tr key={g.key}>
                <td><b>{g.name}</b></td>
                <td>{fmt(g.bet)}</td>
                <td>{fmt(g.paid)}</td>
                <td style={{ color: g.profit >= 0 ? "#16A34A" : "#DC2626", fontWeight: 700 }}>{g.profit >= 0 ? "+" : ""}{fmt(g.profit)}</td>
                <td>{g.bet ? `%${(g.rtp * 100).toFixed(1)}` : "—"}</td>
                <td>
                  <button className={`btn btn-sm ${g.enabled ? "btn-success" : "btn-outline-secondary"}`} style={{ minWidth: 70 }}
                    onClick={async () => { await kaydet({ [g.cfgKey]: !g.enabled }); yukle(); }}>{g.enabled ? "Açık" : "Kapalı"}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ fontSize: 11, color: "#94A3B8" }}>Rakamlar oyun coini cinsinden, oyun açıldığından beri. AYVO'daki aynı oyunların havuzundan ayrıdır.</div>
      <label style={{ fontSize: 12, color: "#6B7280", marginTop: 10, display: "block" }}>
        Deneme hesapları (casino kapalıyken görenler) — ID'leri virgülle ayırın
        <input className="form-control" key={(cfg.gameTesters || []).join(",")} defaultValue={(cfg.gameTesters || []).join(", ")}
          onBlur={(e) => kaydet({ gameTesters: e.target.value.split(/[ ,]+/).map((x) => x.trim()).filter(Boolean) })} />
      </label>
    </Kart>
  );
};

const Odalar = () => {
  const [d, setD] = useState(null);
  const yukle = () => api.gappRooms().then((r) => r?.status && setD(r));
  useEffect(() => { yukle(); }, []);
  const kapat = async (id) => {
    if (!window.confirm("Oda kapatılsın mı?")) return;
    await api.gappRoomClose(id);
    yukle();
  };
  return (
    <Kart baslik="Sesli odalar ve şikayetler" sag={<button className="btn btn-sm btn-outline-secondary" onClick={yukle}>Yenile</button>}>
      <h6 style={{ fontSize: 13, fontWeight: 800 }}>Açık odalar ({(d?.rooms || []).length})</h6>
      <table className="table table-sm" style={{ fontSize: 13 }}>
        <thead><tr><th>Oda</th><th>Sahip</th><th>Mikrofonda</th><th /></tr></thead>
        <tbody>
          {(d?.rooms || []).map((r) => (
            <tr key={r.id}><td>{r.name}</td><td>{r.owner}</td><td>{r.onMic}</td><td><button className="btn btn-sm btn-outline-danger" onClick={() => kapat(r.id)}>Kapat</button></td></tr>
          ))}
          {d && !d.rooms.length && <tr><td colSpan={4} style={{ color: "#9CA3AF" }}>Açık oda yok</td></tr>}
        </tbody>
      </table>
      <h6 style={{ fontSize: 13, fontWeight: 800, marginTop: 12 }}>Son şikayetler ({(d?.reports || []).length})</h6>
      <div style={{ overflowX: "auto" }}>
        <table className="table table-sm" style={{ fontSize: 13 }}>
          <thead><tr><th>Zaman</th><th>Şikayet eden</th><th>Şikayet edilen</th><th>Tür</th></tr></thead>
          <tbody>
            {(d?.reports || []).map((x, i) => (
              <tr key={i}><td>{tarih(x.at)}</td><td>{x.reporter}</td><td>{x.target || "(oda)"}</td><td>{x.reason}</td></tr>
            ))}
            {d && !d.reports.length && <tr><td colSpan={4} style={{ color: "#9CA3AF" }}>Şikayet yok</td></tr>}
          </tbody>
        </table>
      </div>
    </Kart>
  );
};

const AyvoGames = () => {
  const [cfg, setCfg] = useState(null);
  const [st, setSt] = useState(null);
  const [gun, setGun] = useState(7);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.config().then((r) => r?.status && setCfg(r.config));
  }, []);
  useEffect(() => {
    api.gamesAppStats(gun).then((r) => r?.status && setSt(r));
  }, [gun]);

  if (!cfg) return <div className="badu-empty">Yükleniyor…</div>;

  const kaydet = async (degisen) => {
    const r = await api.saveConfig(degisen);
    setMsg(r?.status ? "Kaydedildi — uygulamaya hemen yansır." : r?.message || "Kaydedilemedi");
    if (r?.status) setCfg(r.config);
  };
  const s = st?.stats || {};
  const Kpi = ({ ad, v, renk }) => (
    <div style={{ flex: "1 1 140px", background: "#F8FAFF", borderRadius: 12, padding: 12 }}>
      <div style={{ fontSize: 12, color: "#64748B" }}>{ad}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: renk || "#0F172A" }}>{v}</div>
    </div>
  );

  return (
    <>
      <PageHead title="AYVO Games" sub="Ayrı oyun uygulaması (com.ayvo.games). Bu sayfadaki ayarlar yalnız AYVO Games'i etkiler." right={msg && <span style={{ fontSize: 13, color: "#6B7280" }}>{msg}</span>} />
      <div className="row">
        <div className="col-lg-6">
          <div style={kart}>
            <h6 style={{ fontWeight: 800 }}>Ayarlar</h6>
            {AYARLAR.map(([k, ad, aciklama]) => (
              <div key={k} className="d-flex justify-content-between align-items-start" style={{ padding: "10px 0", borderBottom: "1px solid #F1F5F9", gap: 12 }}>
                <div>
                  <b>{ad}</b>
                  <div style={{ fontSize: 12, color: "#6B7280" }}>{aciklama}</div>
                </div>
                <button className={`btn btn-sm ${cfg[k] !== false && (k !== "gamesAppCasino" || cfg[k]) ? "btn-success" : "btn-outline-secondary"}`} style={{ minWidth: 70 }}
                  onClick={() => kaydet({ [k]: !(cfg[k] !== false && (k !== "gamesAppCasino" || cfg[k])) })}>
                  {cfg[k] !== false && (k !== "gamesAppCasino" || cfg[k]) ? "Açık" : "Kapalı"}
                </button>
              </div>
            ))}
            <div className="d-flex" style={{ gap: 12, marginTop: 12, flexWrap: "wrap" }}>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Bot için bekleme (sn)
                <input className="form-control" type="number" min={3} max={60} defaultValue={cfg.gamesAppBotWait ?? 8} onBlur={(e) => kaydet({ gamesAppBotWait: Math.max(3, Math.min(60, Number(e.target.value) || 8)) })} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Bot düşünme süresi (ms)
                <input className="form-control" type="number" min={500} max={6000} defaultValue={cfg.gamesAppBotThink ?? 1500} onBlur={(e) => kaydet({ gamesAppBotThink: Math.max(500, Math.min(6000, Number(e.target.value) || 1500)) })} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Ludo komisyonu (%)
                <input className="form-control" type="number" min={0} max={40} defaultValue={cfg.ludoFeePct ?? 10} onBlur={(e) => kaydet({ ludoFeePct: Math.max(0, Math.min(40, Number(e.target.value) || 10)) })} />
              </label>
            </div>
            <div className="d-flex" style={{ gap: 12, marginTop: 12, flexWrap: "wrap" }}>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                İlk alışveriş bonusu (%)
                <input className="form-control" type="number" min={0} max={100} defaultValue={cfg.gappFirstBonusPct ?? 10} onBlur={(e) => kaydet({ gappFirstBonusPct: Math.max(0, Math.min(100, Number(e.target.value) || 0)) })} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280", flex: 1, minWidth: 220 }}>
                Günlük giriş ödülü (7 gün, oyun coini, virgülle)
                <input className="form-control" defaultValue={(cfg.gappDailyRewards || [100, 150, 200, 300, 400, 500, 1000]).join(", ")}
                  onBlur={(e) => { const a = e.target.value.split(/[ ,]+/).map(Number).filter((x) => x >= 0 && !isNaN(x)); if (a.length >= 1 && a.length <= 14) kaydet({ gappDailyRewards: a }); }} />
              </label>
            </div>
            <div className="d-flex" style={{ gap: 12, marginTop: 12, flexWrap: "wrap" }}>
              <label style={{ fontSize: 12, color: "#6B7280", flex: 1, minWidth: 220 }}>
                VIP oda bahisleri (virgülle)
                <input className="form-control" defaultValue={(cfg.gamesAppVipBets || [10000, 25000, 50000]).join(", ")}
                  onBlur={(e) => { const a = e.target.value.split(/[ ,]+/).map(Number).filter((x) => x > 0 && !isNaN(x)); if (a.length >= 1 && a.length <= 6) kaydet({ gamesAppVipBets: a }); }} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280", flex: 1, minWidth: 220 }}>
                Turnuva ödülleri (1., 2., 3.)
                <input className="form-control" defaultValue={(cfg.gamesAppTourPrizes || [1000, 500, 250]).join(", ")}
                  onBlur={(e) => { const a = e.target.value.split(/[ ,]+/).map(Number).filter((x) => x >= 0 && !isNaN(x)); if (a.length >= 1 && a.length <= 10) kaydet({ gamesAppTourPrizes: a }); }} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Elmas oranı (kaç oyun coini = 1 elmas)
                <input className="form-control" type="number" min={1} max={100000} defaultValue={cfg.gappDiamondRate ?? 100} onBlur={(e) => kaydet({ gappDiamondRate: Math.max(1, Math.min(100000, Number(e.target.value) || 100)) })} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Hediye alana elmas payı (%)
                <input className="form-control" type="number" min={0} max={100} defaultValue={cfg.gappGiftReceiverPct ?? 0} onBlur={(e) => kaydet({ gappGiftReceiverPct: Math.max(0, Math.min(100, Number(e.target.value) || 0)) })} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Oda hediyesi bölücü (AYVO fiyatı / bu sayı)
                <input className="form-control" type="number" min={1} max={1000} defaultValue={cfg.gappGiftDiv ?? 10} onBlur={(e) => kaydet({ gappGiftDiv: Math.max(1, Math.min(1000, Number(e.target.value) || 10)) })} />
              </label>
              <label style={{ fontSize: 12, color: "#6B7280" }}>
                Ödül için en az galibiyet
                <input className="form-control" type="number" min={1} max={50} defaultValue={cfg.gamesAppTourMinWins ?? 3} onBlur={(e) => kaydet({ gamesAppTourMinWins: Math.max(1, Math.min(50, Number(e.target.value) || 3)) })} />
              </label>
            </div>
            <div style={{ fontSize: 12, color: "#B45309", marginTop: 10 }}>Ludo komisyonu AYVO'daki oda Ludo'suyla ortaktır (aynı oyun motoru).</div>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={kart}>
            <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: 10 }}>
              <h6 style={{ fontWeight: 800, margin: 0 }}>Ludo — son {gun} gün</h6>
              <select className="form-control form-control-sm" style={{ width: 110 }} value={gun} onChange={(e) => setGun(Number(e.target.value))}>
                {[1, 7, 30, 90].map((d) => <option key={d} value={d}>{d} gün</option>)}
              </select>
            </div>
            <div className="d-flex" style={{ gap: 10, flexWrap: "wrap" }}>
              <Kpi ad="Maç" v={fmt(s.matches || 0)} />
              <Kpi ad="Oyuncu" v={fmt(s.players || 0)} />
              <Kpi ad="Gerçek rakipli" v={fmt(s.vsReal || 0)} />
              <Kpi ad="Bota karşı" v={fmt(s.vsBot || 0)} />
              <Kpi ad="Bot kazandı / kaybetti" v={`${s.botWins || 0} / ${s.userWinsVsBot || 0}`} />
              <Kpi ad="Komisyon (gerçek maç)" v={fmt(s.fees || 0)} renk="#16A34A" />
              <Kpi ad="Bot maçlarından net" v={(s.houseVsBot >= 0 ? "+" : "") + fmt(s.houseVsBot || 0)} renk={(s.houseVsBot || 0) >= 0 ? "#16A34A" : "#DC2626"} />
              <Kpi ad="Rakipsiz iptal" v={fmt(s.cancelled || 0)} />
            </div>
            <div style={{ fontSize: 11, color: "#94A3B8", marginTop: 6 }}>Rakamlar oyun coini cinsinden.</div>
          </div>
          <div style={kart}>
            <h6 style={{ fontWeight: 800 }}>Son maçlar</h6>
            <table className="table table-sm" style={{ fontSize: 13 }}>
              <thead><tr><th>Zaman</th><th>Oyuncular</th><th>Bahis</th><th>Durum</th><th>Kazanan</th></tr></thead>
              <tbody>
                {(st?.recent || []).map((m, i) => (
                  <tr key={i}>
                    <td>{new Date(m.at).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</td>
                    <td>{m.players.join(" vs ")}</td>
                    <td>{fmt(m.bet)}</td>
                    <td>{{ done: "Bitti", playing: "Oynanıyor", waiting: "Bekliyor", cancelled: "İptal" }[m.status] || m.status}</td>
                    <td>{m.winner || "—"}</td>
                  </tr>
                ))}
                {!(st?.recent || []).length && <tr><td colSpan={5} style={{ color: "#9CA3AF" }}>Henüz maç yok</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6"><Oyuncular /></div>
        <div className="col-lg-6"><Satislar /></div>
      </div>
      <Casino kaydet={kaydet} cfg={cfg} />
      <Odalar />
    </>
  );
};

export default AyvoGames;
